import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import Title from '../../components/global/Title'

const MemberSatisfactionSurvey = () => {
    const { t } = useTranslation('translation')

    return (
        <div>
            {/* <Title>{t('member.satisfaction-survey')}</Title> */}
            <SurveyContainer>
                <IframeContainer>
                    <iframe
                        src="https://docs.google.com/forms/d/e/1FAIpQLSe7sD1iiRioY6TbqA8AdeK3zpNtahnfkqhEqo9Xp8XASbDXRw/viewform?embedded=true"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        marginHeight={0}
                        marginWidth={0}
                        title={t('member.satisfaction-survey')}
                    >
                        Chargement…
                    </iframe>
                </IframeContainer>
            </SurveyContainer>
        </div>
    )
}

const SurveyContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 24px;
`

const SurveyDescription = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 24px;
    border-radius: 6px;
    background-color: white;
    margin-bottom: 16px;

    p {
        margin-bottom: 12px;
        line-height: 1.6;
        
        &:last-child {
            margin-bottom: 0;
        }
    }
`

const IframeContainer = styled.div`
    width: 100%;
    background-color: white;
    border-radius: 6px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    iframe {
        border: none;
        border-radius: 4px;
        min-height: 600px;
    }

    @media (max-width: 768px) {
        padding: 8px;
        
        iframe {
            height: 600px;
        }
    }
`

export default MemberSatisfactionSurvey
